export const isColumnVisible = ({ visibleColumns, column }) => {
  const hasFilter = visibleColumns.length > 0
  return !hasFilter || visibleColumns.includes(column)
}

/**
 * ★ `readonly` VENCE o filtro de colunas, sempre. `acoes` e uma coluna LOCKED —
 * o `ensureLockedColumns` a reinsere em qualquer preferencia salva — entao a
 * lista NUNCA deixa de conte-la, e o ramo do filtro devolvia `true` mesmo em
 * tela de leitura. O sintoma nao era a coluna: era o KEBAB da linha, que abria
 * o menu inteiro (Editar, Aporte, Resgate, Remover) numa tela onde o ativo nem
 * pertence ao contexto exibido.
 *
 * Leitura nao tem acao. A checagem do filtro so vale quando ha o que mostrar.
 */
export const shouldShowActions = ({ readonly, visibleColumns, allowedActions }) => {
  // Allowlist EXPLICITA vence o `readonly`: o consumidor esta dizendo quais
  // acoes existem naquela tela, em vez de herdar o conjunto inteiro. Sem
  // allowlist (o default), `readonly` continua significando "nenhuma acao".
  if (Array.isArray(allowedActions)) return allowedActions.length > 0
  if (readonly) return false
  const hasFilter = visibleColumns.length > 0
  if (hasFilter) return visibleColumns.includes('acoes')
  return true
}

export const countVisibleColumns = ({ visibleColumns, columns }) => {
  if (!Array.isArray(columns)) return 0
  return columns.filter((column) =>
    isColumnVisible({ visibleColumns, column })
  ).length
}
